import { render, staticRenderFns } from "./consignment.vue?vue&type=template&id=2ec391ce&scoped=true&"
import script from "./consignment.vue?vue&type=script&lang=js&"
export * from "./consignment.vue?vue&type=script&lang=js&"
import style0 from "./consignment.vue?vue&type=style&index=0&id=2ec391ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec391ce",
  null
  
)

export default component.exports